export default {
  s: '%d 秒',
  smicro: '%d 秒',
  smid: '%d 秒',

  ss: '%d 秒',
  ssmicro: '%d 秒',
  ssmid: '%d 秒',

  m: '%d 分',
  mmicro: '%d 分',
  mmid: '%d 分',

  mm: '%d 分',
  mmmicro: '%d 分',
  mmmid: '%d 分',

  h: '%d 時間',
  hmicro: '%d 時間',
  hmid: '%d 時間',

  hh: '%d 時間',
  hhmicro: '%d 時間',
  hhmid: '%d 時間',

  d: '%d 日',
  dmicro: '%d 日',
  dmid: '%d 日',

  dd: '%d 日',
  ddmicro: '%d 日',
  ddmid: '%d 日',
};
